/**
 * @generated SignedSource<<d7bcd39cad9227c727d76aefbc5f7916>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanelItemModule_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModuleDescription_item" | "PdpRespAboutItemPanelItemModuleDetails_item" | "PdpRespSimilarSoldItemsLoading_item" | "PdpRespSimilarSoldItems_item" | "useShouldShowSimilarSoldItems_item">;
  readonly " $fragmentType": "PdpRespAboutItemPanelItemModule_item";
};
export type PdpRespAboutItemPanelItemModule_item$key = {
  readonly " $data"?: PdpRespAboutItemPanelItemModule_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModule_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanelItemModule_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanelItemModuleDescription_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanelItemModuleDetails_item"
    },
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItemsLoading_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_item"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5f05117e8535297077b13a76d398e826";

export default node;
